import {
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader } from '@/src/components/molecules';
import { Section, CardBase } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    background: theme.palette.alternate.main,
    backgroundSize: 'cover',
    padding: theme.spacing(6, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(12, 0),
    },
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  hero: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: 470,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  section: {
    paddingTop: 0,
  },
  sectionHeader: {
    padding: theme.spacing(0, 2),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      maxWidth: '50%',
      width: 'calc(100vw - 625px)',
      marginBottom: 0,
    },
  },
  textWhite: {
    color: 'white',
  },
  image: {
    alignSelf: 'center',
    maxWidth: 625,
    height: 'auto',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      alignSelf: 'flex-end',
      top: '50%',
      right: 0,
      width: 'auto',
      transform: 'translateY(-50%) !important',
    },
  },
  card: {
    borderBottom: `4px solid ${theme.palette.secondary.main}`,
    '& .MuiCardContent-root': {
      padding: 30,
    },
  },
  avatar: {
    width: 90,
    height: 90,
    marginRight: theme.spacing(3),
  },
  cardTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
  },
}));

const About = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <div className={classes.hero}>
        <Section className={classes.section} disablePadding>
          <div className={classes.sectionHeader}>
            <SectionHeader
              title="Experiência completa para venda de produtos ou serviços educacionais"
              subtitle="Nossa plataforma foi construída pensando na simplicidade da transição do offline para o online das instituições e fornecedores educacionais."
              subtitleColor="textPrimary"
              align="left"
              data-aos="fade-up"
            />
            <CardBase withShadow liftUp align="left" className={classes.card}>
              <>
                <Typography className={classes.cardTitle} variant="h6" component="div">
                  Desde o primeiro momento tivemos a oportunidade de experimentar uma relação bem
                  profissional onde a todo instante tínhamos o suporte para as dificuldades e
                  desafios. Isso possibilitou segurança, confiança e agilidade em todo o processo de
                  implantação.
                </Typography>
                <List disablePadding>
                  <ListItem disableGutters>
                    <ListItemAvatar>
                      <Avatar
                        alt="Peterson L."
                        src="/images/illustrations/avatars/man-1.svg"
                        className={classes.avatar}
                      />
                    </ListItemAvatar>
                    <ListItemText primary="Peterson L." secondary="Colégio Adventista Rio Branco" />
                  </ListItem>
                </List>
              </>
            </CardBase>
          </div>
        </Section>
        <Image
          src="/images/illustrations/platform/feature-1.svg"
          className={classes.image}
          data-aos="fade-up"
          lazy={false}
        />
      </div>
    </div>
  );
};

About.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default About;
